import { useState } from "react";
import ReactSwitch from "react-switch";
import styles from "../../styles/_sections/_orders/table.module.scss";

const Table = () => {
  const [checked, setChecked] = useState(false);

  const [collapseState, setCollapseState] = useState([]);

  return (
    <div className={styles.container}>
      <div className={styles.tableContainer}>
        <table>
          <thead>
            <tr>
              {/* checkbox */}
              <th>Checked</th>
              {/* order no */}
              <th>Order no</th>
              {/* arrival date */}
              <th>Arrival Date</th>
              {/* arrival time */}
              <th>Arrival Time</th>
              {/* name of the orderer */}
              <th>Name of the orderer</th>
              {/* mobile */}
              <th>Phone</th>
              {/* remarks */}
              <th>Remarks</th>
              {/* amount */}
              <th>Amount</th>
              {/* details */}
              <th>Details</th>
              {/* payment status */}
              <th>Payment Status</th>
            </tr>
          </thead>

          <tbody>
            {new Array(8).fill(1).map((i, idx) => (
              <>
                <tr>
                  {/* checkbox */}
                  <td>
                    <ReactSwitch
                      onChange={() => setChecked(!checked)}
                      checked={checked}
                      checkedIcon={false}
                      uncheckedIcon={false}
                      offColor={"#fff"}
                      offHandleColor={"#E5E4E2"}
                      handleDiameter={16}
                      className="smallSwitch"
                      width={45}
                      height={22}
                    />
                  </td>
                  {/* order no */}
                  <td>1011</td>
                  {/* arrival date */}
                  <td>22/12/2022</td>
                  {/* arrival time */}
                  <td>12:00:00</td>
                  {/* name of the orderer */}
                  <td>Faygie Schneider</td>
                  {/* mobile */}
                  <td>0547688422</td>
                  {/* remarks */}
                  <td>
                    <input type="text" />
                  </td>
                  {/* amount */}
                  <td>₪105</td>
                  {/* details */}
                  <td
                    onClick={() => {
                      if (collapseState.includes(idx)) {
                        let filteredArr = collapseState.filter(
                          (j) => j !== idx
                        );
                        setCollapseState(filteredArr);
                      } else {
                        setCollapseState((prev) => [...prev, idx]);
                      }
                    }}
                  >
                    <img src="/assets/detailsIcon.png" alt="details" />
                  </td>
                  {/* payment status */}
                  <td>
                    <img src="/assets/checkedIcon.svg" alt="status" />
                  </td>
                </tr>
                {collapseState.includes(idx) && (
                  <tr className={styles.collapsedRow}>
                    <td colspan={10}>
                      <ul>
                        <li>סה"כ כרטיסים שהוזמנו : 6</li>
                        <li>שימוש בקופון : 0</li>
                        <li>
                          אטרקציה ראשית : מבוגר/ת כמות : 3 מחיר : ₪20 אטרקציה :
                          דמי כניסה לאתר צריף בן-גוריון
                        </li>
                        <li>
                          אטרקציה ראשית : ילד/ה (5-18) כמות : 3 מחיר : ₪15
                          אטרקציה : דמי כניסה לאתר צריף בן-גוריון
                        </li>
                        <img src="/assets/pdfBtn.png" alt="" />
                      </ul>
                    </td>
                  </tr>
                )}
              </>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
